import React from 'react';
import {
  Box,
  Card,
  CardContent,
  Typography,
} from '@mui/material';
import { motion } from 'framer-motion';

// 🎥 Video embebido responsivo
const ResponsiveIframe = ({ src }) => (
  <Box
    sx={{
      position: 'relative',
      width: '100%',
      paddingTop: '56.25%', // 16:9 ratio
      borderRadius: 2,
      overflow: 'hidden',
      mt: 1,
    }}
  >
    <iframe
      src={src}
      title="Jugador video"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        border: 0,
      }}
    />
  </Box>
);

const jugadores = [
  {
    nombre: 'Nico Salinas',
    posicion: 'Delantero',
    foto: '/images/messi.jpg',
    video: 'https://www.youtube.com/embed/RVkpf3vGNS4?si=jSrQPf6J_u-ktFTw',
  },
  {
    nombre: 'Adrian Galarza',
    posicion: 'Delantero',
    foto: '/images/ronaldo.jpg',
    video: 'https://www.youtube.com/embed/Ps1284LTzAU?si=md7voVJnlZYPggEQ',
  },
  // Agrega más jugadores aquí
];

const JugadoresPage = () => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: 'linear-gradient(to bottom, #06437c, #0a2239)',
        p: 2,
        display: 'flex',
        flexDirection: 'column',
        gap: 3,
      }}
    >
      {jugadores.map((jugador, index) => (
        <motion.div
          key={jugador.nombre}
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: index * 0.2 }}
        >
          <Card
            sx={{
              width: '100%',
              maxWidth: 400,
              mx: 'auto',
              borderRadius: 3,
              overflow: 'hidden',
              boxShadow: 6,
              backgroundColor: 'white',
            }}
          >
            <img
              src={jugador.foto}
              alt={jugador.nombre}
              style={{
                width: '100%',
                height: 'auto',
                display: 'block',
                objectFit: 'cover',
              }}
            />
            <CardContent>
              <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#0a2239' }}>
                {jugador.nombre}
              </Typography>
              <Typography variant="body2" sx={{ mb: 1 }}>
                {jugador.posicion}
              </Typography>
              <ResponsiveIframe src={jugador.video} />
            </CardContent>
          </Card>
        </motion.div>
      ))}
    </Box>
  );
};

export default JugadoresPage;
